import { configureStore } from "@reduxjs/toolkit";

import dialxyApi from "./endpoints";
import authReducer, { sliceKey as authKey } from "./features/auth/authSlice";
import activeCollapseReducer, {
  sliceKey as activeCollapseKey,
} from "./features/dialer/activeCollapseSlice";
import setActiveReducer, {
  sliceKey as activeDialerKey,
} from "./features/dialer/activeDialerSlice";
import setCallStatusReducer, {
  sliceKey as callStatusKey,
} from "./features/dialer/callStatusSlice";
import setDeviceStatusReducer, {
  sliceKey as deviceKey,
} from "./features/dialer/deviceSlice";
import setMyNumberReducer, {
  sliceKey as myNumberKey,
} from "./features/dialer/myNumberSlice";
import searchReducer, {
  sliceKey as searchKey,
} from "./features/dialer/searchSlice";
import agentIdReducer, {
  sliceKey as agentIdKey,
} from "./features/global/agentIdSlice";
import extensionActivePageReducer, {
  sliceKey as extensionActivePageKey,
} from "./features/global/extensionActivePage";
import iframeReducer, { sliceKey as iframeKey } from "./features/global/iframe";
import globalReducer, {
  sliceKey as globalKey,
} from "./features/global/globalSlice";
import socketReducer, {
  sliceKey as socketKey,
} from "./features/global/socketSlice";
import activeChatHeadReducer, {
  sliceKey as activeChatHeadKey,
} from "./features/tabs/activeChatHeadSlice";
import activeDialerViewReducer, {
  sliceKey as activeDialerViewKey,
} from "./features/tabs/activeDialerViewSlice";
import activePageReducer, {
  sliceKey as activePageKey,
} from "./features/tabs/activePageSlice";
import activeSubMenuReducer, {
  sliceKey as activeSubMenuKey,
} from "./features/tabs/activeSubMenuSlice";
import activeTabViewReducer, {
  sliceKey as activeTabViewKey,
} from "./features/tabs/activeTabViewSlice";

export const makeStore = () =>
  configureStore({
    reducer: {
      [authKey]: authReducer,
      [globalKey]: globalReducer,
      [activePageKey]: activePageReducer,
      [activeSubMenuKey]: activeSubMenuReducer,
      [activeChatHeadKey]: activeChatHeadReducer,
      [activeDialerViewKey]: activeDialerViewReducer,
      [activeCollapseKey]: activeCollapseReducer,
      [activeTabViewKey]: activeTabViewReducer,
      [callStatusKey]: setCallStatusReducer,
      [myNumberKey]: setMyNumberReducer,
      [activeDialerKey]: setActiveReducer,
      [deviceKey]: setDeviceStatusReducer,
      [agentIdKey]: agentIdReducer,
      [dialxyApi.reducerPath]: dialxyApi.reducer,
      [searchKey]: searchReducer,
      [socketKey]: socketReducer,
      [extensionActivePageKey]: extensionActivePageReducer,
      [iframeKey]: iframeReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(dialxyApi.middleware),
  });

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
